<div class="height-100 bg-col-w">
    <div class="flex-column height-100">
        <div class="flex flex-middle p-a-5 p-a-4-s b-b">
            <h6 class="flex-grow flex flex-bottom">
                @if (modalTitle) {
                <span class="h3 col-1">{{modalTitle}}</span>
                }
                @if (modalSubtitle) {
                <span class="p1 col-12 m-l">{{modalSubtitle}}</span>
                }
            </h6>
            <!-- close button -->
            <button role="button"
                    aria-label="Close"
                    (click)="close()"
                    class="inline-flex">
                <i class="icon-close"
                   aria-hidden="true"></i>
            </button>
        </div>

        <!-- body -->
        <div class="overflow-auto custom-scrollbar flex-grow m-t-5 m-t-2-s p-r-5 p-l-5 p-r-4-s p-l-4-s">
            <ng-content select="[modalBody]"></ng-content>
        </div>

        <!-- footer -->
        <div class="w-12 m-t-6 modal-footer p-a-3 p-l-5 p-r-5 p-r-4-s p-l-4-s">
            <ng-content select="[modalFooter]"></ng-content>
        </div>
    </div>
</div>